import Axios from 'axios';

export default Axios.create({
  baseURL: 'https://viacep.com.br/ws',
});
